module.exports = __webpack_public_path__ + "static/circles-a0e5dec2234a922cbb614b4205d9c887.jpg";